import React from "react";

const Thumps = () => {
  return (
    <div>
      <svg
        version="1.1"
        id="lni_lni-thumbs-up"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 64 64"
        className="process-svg"
      >
        <path
          fill="#1CCE7C"
          d="M60.5,26.6c-2.6-5.8-11.4-5.6-16.6-5.4h0c0.6-3.6,1.7-11.3,0.3-13.9c-1.1-2.3-3.3-3.7-5.9-3.9c-2.6-0.2-5,1-6.4,3.3
	c-5.7,8.9-11.2,14.8-13.2,17c0,0-0.1,0.1-0.2,0.1H6.5c-2.6,0-4.8,2.2-4.8,4.8v22.9c0,2.7,2.2,4.8,4.8,4.8h8.9l0.5,0.3
	c0,0,0.1,0,0.1,0.1c2.7,1.8,8.2,3.1,16.2,3.8c1.3,0.1,2.3,0.1,3.5,0.1c6.8,0,13.3-1.7,17.7-4.7C61.9,50.4,64.3,35.2,60.5,26.6z
	 M6.3,51.4V28.5c0-0.2,0.1-0.3,0.3-0.3h5.4v23.5H6.6C6.4,51.8,6.3,51.6,6.3,51.4z M51,52.2c-3.8,2.5-9.3,3.9-15.3,3.9
	c-1.1,0-2,0-3-0.1c-9.8-0.9-13.1-2.4-14.1-3.1l-1-0.7c-0.3-0.2-0.7-0.4-1.1-0.4V28.2h2c1.3,0,2.6-0.5,3.5-1.5
	c2.2-2.2,7.9-8.4,13.8-17.7C36.2,8.2,37,7.8,38,7.9c0.7,0.1,1.7,0.3,2.2,1.4c0.3,0.7,0.5,4.8-0.9,12.1l-0.4,1.5
	c-0.2,0.7,0,1.4,0.4,1.9c0.4,0.5,1.1,0.8,1.8,0.8l2.8,0c3.9-0.1,11.1-0.3,12.4,2.8C59.4,35.2,57.4,48,51,52.2z"
        />
      </svg>
    </div>
  );
};

export default Thumps;
